import script from "./pop-up-empresa.vue?vue&type=script&setup=true&lang=js"
export * from "./pop-up-empresa.vue?vue&type=script&setup=true&lang=js"

import "./pop-up-empresa.vue?vue&type=style&index=0&id=0c0aa9e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c0aa9e2"]])

export default __exports__